import App from '@/models/App'

export default class ShipLaborLocks extends App {
    static get entity() {
        return 'ShipLaborLocks'
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            verify(shipId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.get(`${shipId}/labors/locks/verify`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            save(shipId, params) {
                App.renewalSnackbar(); return Promise.resolve();
                return this.post(
                    `${shipId}/labors/locks/saved`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
